import React from "react";
import * as Auth from "../../domains/AuthDomain";
import standardizeEmail from "../../common/standardizeEmail";
import { FetchCoachOrgLogo } from "../../api/payment.api";
import { getURLVal } from "../../domains/URLDomain";

class VerifyEmail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      emailValid: false,
      emailError: "",
      success: false,
      loading: false,
      logo: "",
      coachOrgId: null,
    };
  }

  componentDidMount = async () => {
    window.scrollTo(0, 0);

    const coachOrgId = getURLVal("cid");

    if (coachOrgId) {
      const logo = await FetchCoachOrgLogo(coachOrgId);
      if (logo) {
        this.setState({ logo });
      }
    }
  };

  renderHeader = () => {
    return (
      <div className="navbar-section-black">
        <div className="navbar-content">
          <div
            className="logo-container"
            onClick={() => {
              window.location.href = "https://trybe.fit";
            }}
          >
            <img
              className="logo-img"
              src={require("../../images/trybe-logo-white.svg")}
            />
            <div className="logo-text">TRYBE</div>
          </div>
        </div>
      </div>
    );
  };

  renderLogo = (logo) => {
    if (!logo) return null;
    return (
      <div className="creator-logo-container">
        <img className="logo-img" src={logo} />
      </div>
    );
  };

  onClickVerifyEmail = async () => {
    this.setState({ loading: true });
    let { email } = this.state;
    const coachOrgId = getURLVal("cid");
    email = standardizeEmail(email);
    const emailValid = Auth.checkEmailValid(email);

    if (emailValid) {
      try {
        const { success, error, error_msg } = await Auth.verifyEmail({
          email,
          coachOrgId,
        });

        if (success) {
          this.setState({
            success: true,
            emailError: false,
            loading: false,
          });
        } else if (error && error_msg) {
          this.setState({
            success: false,
            emailError: error_msg,
            loading: false,
          });
        }
      } catch (err) {
        const message =
          err && err.error_msg
            ? err.error_msg
            : "There was an error sending the verification email. Please contact support@trybe.do";

        this.setState({
          success: false,
          emailError: message,
          loading: false,
        });
      }
    } else {
      this.setState({
        success: false,
        emailError: "Please double check you entered a valid email",
        loading: false,
      });
    }
  };

  render() {
    const promptText = `Please enter the email associated with your account to send a verification email.`;
    const successText = `If there is an account associated with this email, you should receive a verification email within the next 15 minutes. Please check your inbox and follow the instructions to verify your email.`;

    return (
      <div className="verify-email-container">
        {this.renderHeader()}
        <div className="main-form">
          <div className="form-header">Verify Email</div>
          {this.renderLogo(this.state.logo)}
          <div className="padding-wrapper">
            {!this.state.success ? (
              <div className="form-description">{promptText}</div>
            ) : (
              <div className="form-description">{successText}</div>
            )}

            {!this.state.success ? (
              <input
                type="text"
                className="email-input"
                placeholder="E-mail"
                id="login-email"
                maxLength="254"
                onChange={(event) => {
                  this.setState({ email: event.target.value });
                }}
                value={this.state.email}
              />
            ) : null}

            <div className="submit-messages">
              <div className="error-text">
                {this.state.emailError ? this.state.emailError : null}
              </div>
            </div>
            {!this.state.success ? (
              <button
                type="button"
                className="finish-button"
                disabled={!this.state.email}
                onClick={() => {
                  this.onClickVerifyEmail();
                }}
              >
                {this.state.loading ? (
                  <div className="loader" />
                ) : (
                  "SEND VERIFICATION EMAIL"
                )}
              </button>
            ) : null}
          </div>
        </div>
        <div className="contact-us">
          Need further support? Contact us at{" "}
          <a className="link" href="mailto:support@trybe.do">
            support@trybe.do
          </a>
        </div>
      </div>
    );
  }
}

export default VerifyEmail;



// WEBPACK FOOTER //
// ./src/components/pages/VerifyEmail.js